"use client";
import { useState } from "react";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { ArrowForward } from "../icons/arrow-forward";
import { toast } from "sonner";

function SubscriptionForm() {
  const [email, setEmail] = useState("");

  const handleSubscription = async () => {
    const subLoadingId = toast.loading("Subscribing your email...");
    const res = await fetch("/api/newsletter", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    });
    const data = await res.json();
    if (res.ok) {
      toast.success("Subscribed successfully!", { id: subLoadingId });
      setEmail("");
    } else {
      toast.error(data.error || "Subscription failed.", { id: subLoadingId });
    }
  };

  return (
    <>
      {" "}
      <Input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Type in your email, it's free"
        className="rounded-full border-primary-text-700 bg-white h-[44px] text-black pr-10"
      />
      <Button
        size="icon"
        radius="full"
        className="absolute top-1  right-1"
        onClick={handleSubscription}
      >
        <ArrowForward />
      </Button>
    </>
  );
}

export default SubscriptionForm;

